import { styled, Text } from '@obvio/app'
import { SvgChevronRight } from '@obvio/svg'
import { Stack } from '@obvio/ui'

import type { ReactElement } from 'react'

const Wrap = styled(Stack)`
  width: 100%;
  margin-bottom: ${(theme) => theme.spacing.extraLarge};
  text-align: left;
`

const Bar = styled(Stack)`
  width: 100%;
  height: 2.85rem;
  background-color: ${(theme) => theme.colors.additional[2]};
  color: ${(theme) => theme.colors.primary};
  padding: 0 ${(theme) => theme.spacing.medium};
  display: flex;
  align-items: center;
  position: sticky;
  top: calc(var(--nav-height) + calc(${(theme) => theme.spacing.large} * 1.5));
  z-index: 2;
`

type FormSectionProps = {
  title: string
  description?: string
  children: ReactElement[] | ReactElement
}

export function FormBar({
  title,
  className,
}: {
  title: string
  className?: string | undefined
}): ReactElement {
  return (
    <Bar className={className}>
      <SvgChevronRight />
      <Text tag="span">{title}</Text>
    </Bar>
  )
}

export const FormBarMargin = styled(FormBar)`
  margin-bottom: ${(theme) => theme.spacing.large};
  top: var(--nav-height);
`

export function FormSection({
  title,
  description,
  children,
}: FormSectionProps): ReactElement {
  return (
    <Wrap kind="vertical">
      <FormBar title={title} />
      {description ? <Text>{description}</Text> : null}
      {children as unknown as ReactElement}
    </Wrap>
  )
}
